window.addEventListener("DOMContentLoaded", (event) => { // activate the script after everything has loaded
  // actions
  function toggleDropDown(event) {
    let element = this;
    let dropDownBox = document.getElementById("dropDownBox-" + element.getAttribute("data-index"));

    if (element.getAttribute("data-toggle") === "false") {
      if (dropDownBox && dropDownBox.classList.contains("dropDownBox-hidden")) {
        dropDownBox.classList.remove("dropDownBox-hidden");
        dropDownBox.classList.add("dropDownBox-show");
        element.setAttribute("data-toggle", "true");

        element.classList.remove("is-active");
      }
    }
    else if (element.getAttribute("data-toggle") === "true") {
      if (dropDownBox && dropDownBox.classList.contains("dropDownBox-show")) {
        dropDownBox.classList.remove("dropDownBox-show");
        dropDownBox.classList.add("dropDownBox-hidden");
        element.setAttribute("data-toggle", "false");

        element.classList.add("is-active");
      }
    }

    /* if (element.classList.contains('is-active')) {
            element.classList.remove('is-active');
            console.log('removed is-active');
        } else {
            element.classList.add('is-active');
        } */
  }

  // listeners
  try {
    var items = document.getElementsByClassName("accordion-item");
    for (let i = 0; i < items.length; i++) {
      items[i].addEventListener("click", toggleDropDown);
    }
  } catch(err) {}});
